// src/data/pagesIndex.js
const pages = [
  {
    id: "home",
    title: "Home - Pixels Wiki",
    slug: "",
    meta: {
      description: "Welcome to the Pixels Wiki - your comprehensive guide to the Pixels game",
      keywords: ["pixels", "wiki", "guide", "game"],
    },
  },
  {
    id: "starter-guide",
    title: "Starter Guide",
    slug: "wiki/beginner",
    meta: {
      description: "Beginner Guide and Introduction to Pixels",
      keywords: ["starter", "beginner", "guide", "guild", "about pixels", "basics", "vip", "reputation", "currencies", "inventory", "storage"],
    },
  },
  {
    id: "quest-guide",
    title: "Quest Guides",
    slug: "wiki/quests",
    meta: {
      description: "All of the Pixels Quests - Past & Present, with step by step guides on how to complete",
      keywords: ["quests", "guides"],
    },
  },
  {
    id: "skill-guide",
    title: "Skill Guides",
    slug: "wiki/skills",
    meta: {
      description: "A compilation of all of the Pixels Skills, all items crafted within those skills, how to level and how to use",
      keywords: [
        "skills",
        "guides",
        "farming",
        "mining",
        "metalworking",
        "forestry",
        "fishing",
        "animal care",
        "petcare",
        "stoneshaping",
        "woodworking",
        "business",
        "textile",
        "windmill",
      ],
    },
  },
  {
    id: "land-speck-guide",
    title: "Land/Speck Guides",
    slug: "wiki/lands",
    meta: {
      description: "Details and Information on Pixels Lands, Pixels Specks, Discoverability Points, Land Limits, etc",
      keywords: ["land", "guides", "specks", "discoverability", "limits", "land history"],
    },
  },
  {
    id: "pet-guide",
    title: "Pet Guides",
    slug: "wiki/pets",
    meta: {
      description: "Complete Guide on Pets and Pet Minting/Hatching",
      keywords: ["pet", "guides", "hatch", "pet mint", "potions"],
    },
  },
  {
    id: "live-ops",
    title: "Live Ops/Events",
    slug: "wiki/events",
    meta: {
      description: "Past and Current Live Ops Events at Pixels",
      keywords: ["events", "guides", "live ops"],
    },
  },
  {
    id: "changelogs",
    title: "Change Logs",
    slug: "wiki/changelogs",
    meta: {
      description: "Item and Achievement Change Logs from Pixels - track when items and recipes change!",
      keywords: ["items", "guides", "changelogs", "patch notes", "recipe change"],
    },
  },{
    id: "item-lookup",
    title: "Item Lookup",
    slug: "lookup/items",
    meta: {
      description: "Get all data on every single item from the Pixels game",
      keywords: ["lookup", "items"],
    },
  },{
    id: "player-lookup",
    title: "Player Lookup",
    slug: "lookup/players",
    meta: {
      description: "Get data for any Player from the Pixels game",
      keywords: ["lookup", "players", "profile"],
    },
  },{
    id: "land-lookup",
    title: "Land Lookup",
    slug: "lookup/lands",
    meta: {
      description: "Get all data on every single land from the Pixels game",
      keywords: ["lookup", "lands"],
    },
  },{
    id: "guild-lookup",
    title: "Guild Lookup",
    slug: "lookup/guild",
    meta: {
      description: "Get all data on every single guild from the Pixels game",
      keywords: ["lookup", "guild"],
    },
  },{
    id: "energy",
    title: "Energy",
    slug: "tools/energy",
    meta: {
      description: "Get details for energy items, how to gain energy, how you lose energy, and more info about energy",
      keywords: ["tools", "energy", "food", "drinks", "sauna", "how to gain energy"],
    },
  },{
    id: "calculators",
    title: "Calculators",
    slug: "tools/calculator",
    meta: {
      description: "Calculate various things like levels, exp, resources, crafting calculator, energy calculator, CPP Calculator",
      keywords: ["tools", "calculator", "exp", "crafting", "resource", "energy", "cpp"],
    },
  },{
    id: "leaderboards",
    title: "Leaderboards",
    slug: "tools/leaderboards",
    meta: {
      description: "Quickly lookup all leaderboards from the game using this detailed overview",
      keywords: ["tools", "leaderboard"],
    },
  },{
    id: "avatars",
    title: "Avatars",
    slug: "avatars",
    meta: {
      description: "Want to see how your avatar looks in the game? This is the place to do it!",
      keywords: ["avatars", "nfts", "pfp", "profile picture"],
    },
  },{
    id: "pixel-assets",
    title: "Pixel Assets",
    slug: "other/assets",
    meta: {
      description: "A compilation of every Pixel Asset in their library",
      keywords: ["assets", "images"],
    },
  },{
    id: "pixel-calendar",
    title: "Pixels Calendar",
    slug: "other/calendar",
    meta: {
      description: "Upcoming events within the Pixels Universe (IRL, in-game, and other types of events the Pixels team hosts)",
      keywords: ["pixels", "events", "ama", "party"],
    },
  },{
    id: "twitter-overlay",
    title: "Twitter Overlay",
    slug: "other/overlay",
    meta: {
      description: "Get a cute overlay for your Twitter Profile to represent Pixels",
      keywords: ["overlay", "twitter", "x"],
    },
  },{
    id: "aiveronica",
    title: "AI Veronica",
    slug: "wiki/events/aiveronica",
    meta: {
      description: "See detailed information on how to talk to the NPC AIs with the AIVeronica Event",
      keywords: ["AI", "AIVeronica", "Event", "Waifu", "husbando", "key", "how to play", "rooms"],
    },
  },
];

export default pages;
